// src/integrations/jira/manifest.js
import logo from './logo.svg';

const jiraManifest = {
  slug: 'jira_cloud',
  type: 'Integrations::JiraCloudIntegration', // must match the backend STI type
  displayName: 'Jira Cloud',
  // Shown where other integrations explain asset sync. This one syncs no assets: it links tasks
  // to issues that already exist upstream.
  asset_sync_message: 'Jira does not sync assets. It links tasks to existing Jira issues, then '
    + 'comments on and transitions them as field work progresses.',
  logo,
  colorClass: 'bg-white',
};

export default jiraManifest;
